import '~/styles/page/write-logo.css'

const WriteLogo = () => {
  return <span className="gorge-signature">Gorge</span>
}

export default WriteLogo
